export const API_VERSION = {
	V_2023_04_26: "2023-04-26",
	V_2023_05_16: "2023-05-16",
};
